import { render, staticRenderFns } from "./TopicLinkCreate.vue?vue&type=template&id=16b88c12"
import script from "./TopicLinkCreate.vue?vue&type=script&lang=js"
export * from "./TopicLinkCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports